import { jwtDecode } from "jwt-decode";
import { isEmpty } from './entitySelector';

export const getToken = () => {
    const tokenData = JSON.parse(localStorage.getItem("TECHPOS"));
    
    if (tokenData) {
        try {
            let decoded = jwtDecode(tokenData.token);
            if (decoded.exp * 1000 <= new Date().getTime()) {
                throw "Expired jwt";
            }
            return tokenData.token;
        } catch (error) {
            console.log("error token: " + error);
            return tokenData.token;
        }
    }

    return null;
};